import * as React from "react";

function CloseIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" {...props}>
      <path d="M29.224 4.824L18.856 15l10.37 10.176c1 .986 1 2.62 0 3.608l-.467.443c-1 .987-2.667.987-3.667 0l-10.105-9.905L4.884 29.26c-1 .987-2.667.987-3.668 0l-.466-.443c-1-.986-1-2.62 0-3.608l10.37-10.21L.75 4.825c-1-.986-1-2.62 0-3.608l.466-.443c1-.987 2.668-.987 3.668 0l10.103 9.905L25.09.74c1-.987 2.668-.987 3.668 0l.466.443a2.523 2.523 0 010 3.641z" />
    </svg>
  );
}

const MemoCloseIcon = React.memo(CloseIcon);
export default MemoCloseIcon;
